import { render, staticRenderFns } from "./KeyThirtyOne.vue?vue&type=template&id=10d68a87&scoped=true&"
import script from "./KeyThirtyOne.vue?vue&type=script&lang=js&"
export * from "./KeyThirtyOne.vue?vue&type=script&lang=js&"
import style0 from "./KeyThirtyOne.vue?vue&type=style&index=0&id=10d68a87&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10d68a87",
  null
  
)

export default component.exports